<template>
  <form
    :id="`social-login-form-${provider}`"
    ref="loginForm"
    :action="formAction"
    method="POST"
  >
    <tc-v-btn
      :id="`social-login-submit-button-${provider}`"
      outlined
      large
      :class="`btn-social btn-${provider} btn-${provider} fs-unmask`"
      @click="login"
    >
      {{ $t(signWithProvideri18nKey, {provider: providerString}) }}
    </tc-v-btn>
    <input
      name="_csrf"
      type="hidden"
      :value="csrf"
    >
    <input
      :id="`success-uri-${provider}`"
      name="successUri"
      type="hidden"
      :value="successRedirect"
    >
    <input
      :id="`failure-uri-${provider}`"
      name="failureUri"
      type="hidden"
      :value="failureRedirect"
    >
  </form>
</template>

<script>
import { LoginMixin } from '@/components/shared/mixins/LoginMixin'
import { SSO_CLICKED } from '../shared/segment/track-user-management'
import { get } from 'tiny-cookie'
import { LoginMethodTypes } from '@/components/authentication/enum/LoginMethodType'

export default {
  name: 'SocialLogin',
  mixins: [LoginMixin],
  props: {
    provider: {
      type: String,
      required: true,
      validator: function (value) {
        return ['google', 'auth0'].indexOf(value) !== -1
      }
    },
    signWithProvideri18nKey: {
      type: String,
      required: true
    }
  },
  computed: {
    formAction () {
      const { rgfeApiHost, provider } = this
      return `${rgfeApiHost}/signin/oauth2/authorize/${provider}`
    },
    providerString () {
      return {
        google: LoginMethodTypes.GOOGLE,
        auth0: LoginMethodTypes.AUTH0
      }[this.provider] || ''
    },
    csrf () {
      return get('XSRF-TOKEN')
    },
    successRedirect () {
      if (LoginMethodTypes.AUTH0 === this.providerString) {
        return this.successRedirectHome
      }
      return this.successRedirectMFA
    }
  },
  methods: {
    async login () {
      await this.$segment.track(SSO_CLICKED)
      this.$refs.loginForm.submit()
    }
  }
}
</script>

<style scoped lang="scss">

  .btn-social {
    border-radius: 4px;
    height: 48px;
    padding: 0;
    width: 99%;
    cursor: pointer;
    box-shadow: none;
    border: 1px solid var(--t-color-border);
    color: inherit;

    &:hover {
      color: inherit;
    }
    &:focus {
      color: inherit;
      outline: none;
    }
  }

  .btn-google {
    background: url('../../assets/images/google-signin-icon.svg') no-repeat 10px;
    background-size: 30px 30px; // IE11 needs width and height set

    &:active {
      background: url('../../assets/images/google-signin-icon.svg') no-repeat 10px;
      background-size: 30px 30px; // IE11 needs width and height set
    }
  }

  .btn-auth0 {
    background: url('../../assets/images/tango-smile.svg') no-repeat 10px;
    background-size: 30px 30px; // IE11 needs width and height set

    &:active {
      background: url('../../assets/images/tango-smile.svg') no-repeat 10px;
      background-size: 30px 30px; // IE11 needs width and height set
    }
  }

  .btn-login {
    width: 99%;
    min-width: 250px;
  }
</style>
